// Authentication screens + user menu + account settings.
const auth = {
  en: {
    'auth.welcomeHeading': 'Welcome!',
    'auth.welcomeSubtitle': 'Plan your garden, track your harvest, and never miss a task.',
    'auth.back': 'Back',
    'auth.email': 'Email',
    'auth.password': 'Password',
    'auth.passwordPlaceholder': 'Enter your password',
    'auth.forgotPassword': 'Forgot password?',
    'auth.signIn': 'Sign In',
    'auth.signingIn': 'Signing in...',
    'auth.continueWithGoogle': 'Continue with Google',
    'auth.orContinueWith': 'or continue with',
    'auth.orSignUpWith': 'or sign up with',
    'auth.showPassword': 'Show password',
    'auth.hidePassword': 'Hide password',
    'auth.signUp': 'Sign Up',
    'auth.createAccount': 'Create Account',
    'auth.fullName': 'Name',
    'auth.or': 'or',
    'auth.createPasswordPlaceholder': 'Create a password',
    'auth.confirmPassword': 'Confirm Password',
    'auth.confirmPasswordPlaceholder': 'Confirm your password',
    'auth.creatingAccount': 'Creating Account...',
    'auth.language': 'Language',
    'auth.resetPassword': 'Reset password',
    'auth.resetInstructions': "Enter your email and we'll send you a link to reset your password.",
    'auth.sendResetLink': 'Send reset link',
    'auth.sending': 'Sending...',
    'auth.backToLogin': 'Back to Sign In',
    'auth.resetEmailSent': 'Check your email for a link to reset your password.',
    'auth.fillAllFields': 'Please fill in all fields',
    'auth.signInFailed': 'Failed to sign in. Please check your credentials.',
    'auth.googleFailed': 'Failed to sign in with Google.',
    'auth.passwordsNoMatch': 'Passwords do not match',
    'auth.passwordTooShort': 'Password must be at least {min} characters',
    'auth.emailInUse': 'Email is already in use',
    'auth.invalidEmail': 'Invalid email address',
    'auth.weakPassword': 'Password is too weak',
    'auth.createFailed': 'Failed to create account. Please try again.',
    'auth.resetFailed': 'Failed to send reset email. Please try again.',
    'auth.enterEmail': 'Please enter your email address',
    // Reset password action (link from email)
    'auth.verifyingLink': 'Verifying your reset link...',
    'auth.resetLinkInvalid': 'This password reset link is invalid or has expired. Please request a new one.',
    'auth.setNewPassword': 'Set a new password',
    'auth.newPasswordFor': 'Choose a new password for {email}',
    'auth.updatePassword': 'Update Password',
    'auth.updatingPassword': 'Updating...',
    'auth.passwordUpdated': 'Password updated!',
    'auth.passwordUpdatedDesc': 'You can now sign in with your new password.',
    'auth.continueToSignIn': 'Continue to Sign In',
    // Email change action (link from email)
    'auth.emailLinkInvalidTitle': 'Link Invalid',
    'auth.emailLinkInvalid': 'This link is invalid or has expired. Please try again from Account Settings.',
    'auth.emailChanged': 'Email Updated',
    'auth.emailChangedDesc': 'Your email has been changed to {email}.',
    'auth.emailChangedDescGeneric': 'Your email has been changed.',
    'auth.emailChangeReverted': 'Email Change Reverted',
    'auth.emailChangeRevertedDesc': 'The email change has been undone and your account is back to its previous address.',
    'auth.emailChangeRevertedNotice': "If you didn't request this change, we recommend resetting your password right away.",
    // User menu
    'auth.user': 'User',
    'auth.userMenu': 'User menu',
    'auth.accountSettings': 'Account Settings',
    'auth.signOut': 'Sign out',
  },
  lt: {
    'auth.welcomeHeading': 'Sveiki!',
    'auth.welcomeSubtitle': 'Planuokite daržą, sekite derlių ir nepraleiskite nei vienos užduoties.',
    'auth.back': 'Atgal',
    'auth.email': 'El. paštas',
    'auth.password': 'Slaptažodis',
    'auth.passwordPlaceholder': 'Įveskite slaptažodį',
    'auth.forgotPassword': 'Pamiršote slaptažodį?',
    'auth.signIn': 'Prisijungti',
    'auth.signingIn': 'Jungiamasi...',
    'auth.continueWithGoogle': 'Tęsti su Google',
    'auth.orContinueWith': 'arba tęskite su',
    'auth.orSignUpWith': 'arba registruokitės su',
    'auth.showPassword': 'Rodyti slaptažodį',
    'auth.hidePassword': 'Slėpti slaptažodį',
    'auth.signUp': 'Registruotis',
    'auth.createAccount': 'Sukurti paskyrą',
    'auth.fullName': 'Vardas',
    'auth.or': 'arba',
    'auth.createPasswordPlaceholder': 'Sukurkite slaptažodį',
    'auth.confirmPassword': 'Pakartokite slaptažodį',
    'auth.confirmPasswordPlaceholder': 'Pakartokite slaptažodį',
    'auth.creatingAccount': 'Kuriama paskyra...',
    'auth.language': 'Kalba',
    'auth.resetPassword': 'Atkurti slaptažodį',
    'auth.resetInstructions': 'Įveskite el. paštą ir atsiųsime nuorodą slaptažodžiui atkurti.',
    'auth.sendResetLink': 'Siųsti nuorodą',
    'auth.sending': 'Siunčiama...',
    'auth.backToLogin': 'Grįžti į prisijungimą',
    'auth.resetEmailSent': 'Patikrinkite el. paštą – atsiuntėme nuorodą slaptažodžiui atkurti.',
    'auth.fillAllFields': 'Užpildykite visus laukus',
    'auth.signInFailed': 'Nepavyko prisijungti. Patikrinkite prisijungimo duomenis.',
    'auth.googleFailed': 'Nepavyko prisijungti su Google.',
    'auth.passwordsNoMatch': 'Slaptažodžiai nesutampa',
    'auth.passwordTooShort': 'Slaptažodį turi sudaryti bent {min} simboliai',
    'auth.emailInUse': 'Šis el. paštas jau naudojamas',
    'auth.invalidEmail': 'Neteisingas el. pašto adresas',
    'auth.weakPassword': 'Slaptažodis per silpnas',
    'auth.createFailed': 'Nepavyko sukurti paskyros. Bandykite dar kartą.',
    'auth.resetFailed': 'Nepavyko išsiųsti laiško. Bandykite dar kartą.',
    'auth.enterEmail': 'Įveskite el. pašto adresą',
    // Reset password action (link from email)
    'auth.verifyingLink': 'Tikrinama nuoroda...',
    'auth.resetLinkInvalid': 'Ši slaptažodžio atkūrimo nuoroda negalioja arba jos galiojimo laikas pasibaigė. Užsisakykite naują.',
    'auth.setNewPassword': 'Nustatykite naują slaptažodį',
    'auth.newPasswordFor': 'Pasirinkite naują slaptažodį paskyrai {email}',
    'auth.updatePassword': 'Atnaujinti slaptažodį',
    'auth.updatingPassword': 'Atnaujinama...',
    'auth.passwordUpdated': 'Slaptažodis atnaujintas!',
    'auth.passwordUpdatedDesc': 'Dabar galite prisijungti nauju slaptažodžiu.',
    'auth.continueToSignIn': 'Tęsti prie prisijungimo',
    // Email change action (link from email)
    'auth.emailLinkInvalidTitle': 'Nuoroda negalioja',
    'auth.emailLinkInvalid': 'Ši nuoroda negalioja arba jos galiojimo laikas pasibaigė. Bandykite dar kartą paskyros nustatymuose.',
    'auth.emailChanged': 'El. paštas atnaujintas',
    'auth.emailChangedDesc': 'Jūsų el. paštas pakeistas į {email}.',
    'auth.emailChangedDescGeneric': 'Jūsų el. paštas pakeistas.',
    'auth.emailChangeReverted': 'El. pašto keitimas atšauktas',
    'auth.emailChangeRevertedDesc': 'El. pašto keitimas atšauktas, paskyra grąžinta į ankstesnį adresą.',
    'auth.emailChangeRevertedNotice': 'Jei šio pakeitimo neprašėte, rekomenduojame nedelsiant atkurti slaptažodį.',
    // User menu
    'auth.user': 'Naudotojas',
    'auth.userMenu': 'Naudotojo meniu',
    'auth.accountSettings': 'Paskyros nustatymai',
    'auth.signOut': 'Atsijungti',
  },
};

export default auth;
